// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * NextWork API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Goal } from './goal';
import {
    GoalFromJSON,
    GoalFromJSONTyped,
    GoalToJSON,
    GoalToJSONTyped,
} from './goal';
import type { SearchResults } from './searchResults';
import {
    SearchResultsFromJSON,
    SearchResultsFromJSONTyped,
    SearchResultsToJSON,
    SearchResultsToJSONTyped,
} from './searchResults';

/**
 * 
 * @export
 * @interface GoalRoadmap
 */
export interface GoalRoadmap {
    /**
     * 
     * @type {Goal}
     * @memberof GoalRoadmap
     */
    goal: Goal;
    /**
     * 
     * @type {SearchResults}
     * @memberof GoalRoadmap
     */
    suggestedRoadmap: SearchResults;
}

/**
 * Check if a given object implements the GoalRoadmap interface.
 */
export function instanceOfGoalRoadmap(value: object): value is GoalRoadmap {
    if (!('goal' in value) || value['goal'] === undefined) return false;
    if (!('suggestedRoadmap' in value) || value['suggestedRoadmap'] === undefined) return false;
    return true;
}

export function GoalRoadmapFromJSON(json: any): GoalRoadmap {
    return GoalRoadmapFromJSONTyped(json, false);
}

export function GoalRoadmapFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoalRoadmap {
    if (json == null) {
        return json;
    }
    return {
        
        'goal': GoalFromJSON(json['goal']),
        'suggestedRoadmap': SearchResultsFromJSON(json['suggestedRoadmap']),
    };
}

export function GoalRoadmapToJSON(json: any): GoalRoadmap {
    return GoalRoadmapToJSONTyped(json, false);
}

export function GoalRoadmapToJSONTyped(value?: GoalRoadmap | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'goal': GoalToJSON(value['goal']),
        'suggestedRoadmap': SearchResultsToJSON(value['suggestedRoadmap']),
    };
}

